module.exports = __webpack_public_path__ + "static/img/Frame17.97f32742.png";